import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { Button, message, Tooltip } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { PrintLabelThunk } from "../../../store/thunks/orderThunk";
import { useDispatch, useSelector } from "react-redux";
import { resetLabel } from "../../../store/slices/orderSlice";

export const OrderTable = ({
  list = [],
  tabKey,
  submit,
  offset,
  isSuperAdmin,
  createManifest,
  setOrderIds,
  orderIds,
  selectedShipments,
  setSelectedShipments,
  createInvoice,
  setInvoiceOrderRefIds,
  invoiceOrderRefIds,

  selectedInvoiceShipments,
  setSelectedInvoiceShipments,
}) => {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.printInvoice);
  const { data: label } = useSelector((state) => state.printLabel);

  useEffect(() => {
    data?.invoiceUrl &&
      window.open(data?.invoiceUrl, "_blank", "noopener,noreferrer");
  }, [data?.invoiceUrl]);

  useEffect(() => {
    setOrderIds(selectedShipments.map((item) => item.orderKey));
  }, [selectedShipments, setOrderIds]);

  // useEffect(() => {
  //   setInvoiceOrderRefIds(
  //     selectedInvoiceShipments.map((item) => item.orderRefId),
  //   );
  // }, [selectedInvoiceShipments, setInvoiceOrderRefIds]);

  useEffect(() => {
    if (typeof setInvoiceOrderRefIds !== "function") return;

    setInvoiceOrderRefIds(
      (selectedInvoiceShipments || []).map((item) => item.orderRefId),
    );
  }, [selectedInvoiceShipments, setInvoiceOrderRefIds]);

  console.log(
    "invoiceOrderRefIdsinvoiceOrderRefIdsinvoiceOrderRefIds",
    invoiceOrderRefIds,
  );
  useEffect(() => {
    const pdfContent = label?.pdfContent;
    if (label) {
      if (pdfContent) {
        // Convert base64 to a downloadable PDF Blob
        const byteCharacters = atob(pdfContent);
        const byteNumbers = Array.from(byteCharacters, (c) => c.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });

        // Create a download link
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "shipping-label.pdf";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } else if (label?.label_url) {
        // Fallback to opening the label_url in new tab
        window.open(label?.label_url, "_blank", "noopener,noreferrer");
      } else {
        message.error("No PDF content or label URL found.");
      }
    }
    dispatch(resetLabel());
  }, [label?.label_url]);

  const getShipmentId = (shipment) =>
    shipment?.shipRockedShipmentId ||
    shipment?.prozoAwbNumber ||
    shipment?.courierPartnerShipmentId;

  const isEligibleShipment = (shipment) =>
    shipment?.shippingPartner === "DELHIVERY_ONE" &&
    shipment?.orderStatus === "PACKED" &&
    !!getShipmentId(shipment);

  const handleRowSelection = (shipment, checked) => {
    if (checked) {
      setSelectedShipments((prev) => {
        if (
          prev.some((item) => getShipmentId(item) === getShipmentId(shipment))
        ) {
          return prev;
        }
        return [...prev, shipment];
      });
    } else {
      setSelectedShipments((prev) =>
        prev.filter((item) => getShipmentId(item) !== getShipmentId(shipment)),
      );
    }
  };

  const isEligibleInvoiceShipment = (shipment) => !!getShipmentId(shipment);

  const eligibleShipments = (list || []).filter(isEligibleShipment);

  const eligibleInvoiceShipments = (list || []).filter(
    isEligibleInvoiceShipment,
  );

  const handleInvoiceRowSelection = (shipment, checked) => {
    if (checked) {
      setSelectedInvoiceShipments((prev) => {
        if (
          prev.some((item) => getShipmentId(item) === getShipmentId(shipment))
        ) {
          return prev;
        }

        return [...prev, shipment];
      });
    } else {
      setSelectedInvoiceShipments((prev) =>
        prev.filter((item) => getShipmentId(item) !== getShipmentId(shipment)),
      );
    }
  };

  const handleSelectAll = (e) => {
    const eligible = (list || []).filter(isEligibleShipment);

    if (e.target.checked) {
      setSelectedShipments((prev) => {
        const selectedShipmentIds = new Set(
          prev.map((item) => getShipmentId(item)),
        );

        const newItems = eligible.filter(
          (item) => !selectedShipmentIds.has(getShipmentId(item)),
        );

        return [...prev, ...newItems];
      });
    } else {
      setSelectedShipments([]);
      setOrderIds([]);
    }
  };

  const handleInvoiceSelectAll = (checked) => {
    if (checked) {
      setSelectedInvoiceShipments((prev) => {
        const selectedShipmentIds = new Set(
          prev.map((item) => getShipmentId(item)),
        );

        const newItems = eligibleInvoiceShipments.filter(
          (item) => !selectedShipmentIds.has(getShipmentId(item)),
        );

        return [...prev, ...newItems];
      });
    } else {
      setSelectedInvoiceShipments((prev) =>
        prev.filter(
          (item) =>
            !eligibleInvoiceShipments.some(
              (selected) => getShipmentId(selected) === getShipmentId(item),
            ),
        ),
      );
    }
  };

  return (
    <div className="table-responsive">
      <table className="table table-bordered m-0 border radius-remove all_domain_table">
        <thead className="text-white bg-gray-700">
          <tr>
            {createManifest && (
              <th className="width">
                Manifest
                {isSuperAdmin && (
                  <div className="mt-2">
                    <Tooltip title="Select/Deselect all eligible shipments">
                      <input
                        type="checkbox"
                        checked={
                          eligibleShipments.length > 0 &&
                          eligibleShipments.every((item) =>
                            selectedShipments.some(
                              (sel) =>
                                getShipmentId(sel) === getShipmentId(item),
                            ),
                          )
                        }
                        onChange={handleSelectAll}
                      />
                    </Tooltip>
                  </div>
                )}
              </th>
            )}

            {createInvoice && (
              <th className="width">
                Invice
                {isSuperAdmin && (
                  <div className="mt-2">
                    <Tooltip title="Select/Deselect all eligible shipments">
                      <input
                        type="checkbox"
                        // checked={
                        //   eligibleShipments.length > 0 &&
                        //   eligibleShipments.every((item) =>
                        //     selectedInvoiceShipments.some(
                        //       (sel) =>
                        //         getShipmentId(sel) === getShipmentId(item),
                        //     ),
                        //   )
                        // }
                        checked={
                          eligibleInvoiceShipments.length > 0 &&
                          eligibleInvoiceShipments.every((item) =>
                            selectedInvoiceShipments.some(
                              (sel) =>
                                getShipmentId(sel) === getShipmentId(item),
                            ),
                          )
                        }
                        onChange={(e) =>
                          handleInvoiceSelectAll(e.target.checked)
                        }
                      />
                    </Tooltip>
                  </div>
                )}
              </th>
            )}

            <th className="font-weight-bolder font-size-lg all_table_id_number">
              Item/Order Id
            </th>
            <th className="width">Purchased</th>
            <th className="width">Products</th>
            <th className="width">Delivery Method</th>
            <th className="width">Settlement Value</th>
            <th className="width">Selling Price</th>
            <th className="width">Order Status</th>
            <th className="width">Settlement Status</th>
            <th className="width">Courier Partner</th>
            <th className="width">Order Date</th>
            <th className="width">Action</th>
          </tr>
        </thead>
        <tbody>
          {list && list.length > 0 ? (
            list.map((dataList, index) => {
              const refId = dataList?.orderRefID;
              const shipmentId = dataList?.shipRockedShipmentId
                ? dataList?.shipRockedShipmentId
                : dataList?.prozoAwbNumber
                  ? dataList?.prozoAwbNumber
                  : dataList?.courierPartnerShipmentId;

              return (
                <tr
                  key={index.toString()}
                  className={
                    (selectedShipments || []).some(
                      (item) => item.orderKey === dataList.orderKey,
                    ) ||
                    (selectedInvoiceShipments || []).some(
                      (item) => getShipmentId(item) === getShipmentId(dataList),
                    )
                      ? "table-primary"
                      : ""
                  }
                >
                  {createManifest && (
                    <td className="text-center">
                      {isSuperAdmin &&
                      dataList?.shippingPartner === "DELHIVERY_ONE" &&
                      dataList?.orderStatus === "PACKED" &&
                      shipmentId ? (
                        <div className="mt-2">
                          <Tooltip title="Select to Generate Manifest">
                            <input
                              type="checkbox"
                              checked={selectedShipments.some(
                                (item) =>
                                  getShipmentId(item) ===
                                  getShipmentId(dataList),
                              )}
                              onChange={(e) =>
                                handleRowSelection(dataList, e.target.checked)
                              }
                            />
                          </Tooltip>
                        </div>
                      ) : isSuperAdmin &&
                        dataList?.shippingPartner === "DELHIVERY_ONE" &&
                        dataList?.orderStatus != "PACKED" ? (
                        <div className="mt-2">
                          <Tooltip title="Not eligible for manifest">
                            <input type="checkbox" disabled />
                          </Tooltip>
                        </div>
                      ) : (
                        ""
                      )}
                    </td>
                  )}

                  {/* {createInvoice && (
                    <td className="text-center">
                      {isSuperAdmin &&
                      shipmentId ? (
                        <div className="mt-2">
                          <Tooltip title="Select to Generate Invoice">
                            <input
                              type="checkbox"
                              checked={selectedInvoiceShipments.some(
                                (item) =>
                                  getShipmentId(item) ===
                                  getShipmentId(dataList),
                              )}
                              onChange={(e) =>
                                handleInvoiceRowSelection(dataList, e.target.checked)
                              }
                            />
                          </Tooltip>
                        </div>
                      ) : isSuperAdmin &&
                        dataList?.shippingPartner === "DELHIVERY_ONE" &&
                        dataList?.orderStatus != "PACKED" ? (
                        <div className="mt-2">
                          <Tooltip title="Not eligible for manifest">
                            <input type="checkbox" disabled />
                          </Tooltip>
                        </div>
                      ) : (
                        ""
                      )}
                    </td>
                  )} */}

                  {createInvoice && (
                    <td className="text-center">
                      {isSuperAdmin && shipmentId ? (
                        <div className="mt-2">
                          <Tooltip title="Select to Generate Invoice">
                            <input
                              type="checkbox"
                              checked={selectedInvoiceShipments.some(
                                (item) =>
                                  getShipmentId(item) ===
                                  getShipmentId(dataList),
                              )}
                              onChange={(e) =>
                                handleInvoiceRowSelection(
                                  dataList,
                                  e.target.checked,
                                )
                              }
                            />
                          </Tooltip>
                        </div>
                      ) : (
                        ""
                      )}
                    </td>
                  )}

                  <td className="">
                    {/* {dataList?.orderRefId} <br />
                    <hr />  */}

                    {dataList?.orderKey}
                  </td>
                  <td className="font-weight-bolder text-left">
                    <div className="my-2">{dataList.byRefId.length} items</div>
                    <div className="my-2">by {dataList.customerName?.en}</div>
                    <div className="my-2">({dataList.customerId})</div>
                  </td>
                  <td className="">
                    {dataList.byRefId &&
                      dataList.byRefId.map((products, i) => {
                        return (
                          <div className="my-2 text-capitalize font-weight-bolder text-left">
                            {products.productName.en} -{" "}
                            {products?.variant
                              ? products?.variant
                              : products?.modelNumber}{" "}
                            ({products?.quantity})
                          </div>
                        );
                      })}
                  </td>
                  <td className="font-weight-bolder text-nowrap">
                    <span
                      className={`rounded py-1 px-2 font-weight-bold font-size-sm text-nowrap ${
                        dataList?.deliveryWay === "HOME_DELIVERY"
                          ? "text-white bg-info"
                          : "text-white bg-warning"
                      }`}
                    >
                      {dataList?.deliveryWay === "HOME_DELIVERY"
                        ? "HOME DELIVERY"
                        : "PICK UP"}
                    </span>
                  </td>
                  <td>
                    {dataList?.orderStatus === "DELIVERED" ||
                    dataList?.orderStatus === "LOST"
                      ? dataList?.settlementValue != null
                        ? "₹" + dataList.settlementValue
                        : ""
                      : dataList?.orderStatus === "CANCELLED" ||
                          dataList?.orderStatus === "RTO_DELIVERED"
                        ? "₹ 0"
                        : ""}
                  </td>

                  <td className="" nowrap="nowrap">
                    <div className="my-2">
                      Rs. <span>{dataList.earning}</span>
                    </div>
                    <div className="my-2">
                      <span
                        className={`rounded p-1 px-2 font-weight-bold font-size-sm ${
                          dataList.paymentMethod === "CASH_ON_DELIVERY"
                            ? "bg-warning text-white"
                            : "bg-success text-white"
                        }`}
                      >
                        {dataList.paymentMethod === "CASH_ON_DELIVERY"
                          ? "CASH ON DELIVERY"
                          : "PRE-PAID"}
                      </span>
                    </div>
                  </td>
                  <td className="" nowrap="nowrap">
                    <span
                      className={
                        dataList?.orderStatus === "DELIVERED"
                          ? "bg-primary p-1 px-2 text-white rounded font-size-sm"
                          : dataList?.orderStatus === "CANCELLED"
                            ? "bg-danger rounded p-1 px-2 text-white font-size-sm"
                            : dataList?.orderStatus === "PACKED"
                              ? "bg-gray-700 rounded p-1 px-2 text-white font-size-sm"
                              : dataList?.orderStatus ===
                                  "PICKED_READY_FOR_SHIPPED"
                                ? "picked_ready p-1 px-2 text-white rounded font-size-sm"
                                : dataList?.orderStatus === "ACCEPTED"
                                  ? "seller_accepted p-1 px-2 text-white rounded font-size-sm"
                                  : dataList?.orderStatus === "OUT_FOR_DELIVERY"
                                    ? "out-for-delovery p-1 px-2 text-white rounded font-size-sm"
                                    : dataList?.orderStatus ===
                                        "SHIPMENT_CANCELLED"
                                      ? "bg-danger rounded p-1 px-2 text-white font-size-sm"
                                      : dataList?.orderStatus === "PROCESSING"
                                        ? "seller-process p-1 px-2 text-white rounded font-size-sm"
                                        : dataList?.orderStatus ===
                                            "RTO_INITIATED"
                                          ? "bg-gray-700 rounded p-1 px-2 text-white font-size-sm"
                                          : "bg-warning rounded p-1 px-2 text-white font-size-sm"
                      }
                    >
                      {" "}
                      {dataList.orderStatus.toUpperCase() === "SHIPPED"
                        ? "In-transit"
                        : dataList.orderStatus}
                    </span>
                    <div className="my-2">
                      <span
                        className={`rounded p-1 px-2 font-weight-bold font-size-sm  ${
                          dataList?.isPreBooked
                            ? "bg-success mt-3 text-white"
                            : ""
                        }`}
                      >
                        {dataList?.isPreBooked ? "PRE-BOOKED" : ""}
                      </span>
                    </div>
                  </td>
                  <td className="" nowrap="nowrap">
                    <div className="my-2">
                      <span
                        className={
                          dataList?.settlementStatus === "DONE"
                            ? "bg-primary p-1 px-2 text-white rounded font-size-sm"
                            : dataList?.settlementStatus === "PENDING"
                              ? "bg-warning rounded p-1 px-2 text-white font-size-sm"
                              : ""
                        }
                      >
                        {dataList?.settlementStatus === "DONE"
                          ? "PAID"
                          : dataList?.settlementStatus === "PENDING"
                            ? "UNPAID"
                            : ""}
                      </span>
                    </div>
                  </td>

                  <td className="" nowrap="nowrap">
                    <div className="my-2">
                      {dataList?.isShipmentCancelled ? (
                        ""
                      ) : dataList?.deliveryMode === "SELF" ? (
                        <span className={""}></span>
                      ) : dataList?.externalDeliveryMode ===
                        "IN_HOUSE_SERVICE_SERVICE" ? (
                        <span
                          className={
                            "bg-gray-700 rounded p-1 px-2 text-white font-size-sm"
                          }
                        >
                          Apni Kheti
                        </span>
                      ) : dataList?.externalDeliveryMode ===
                        "EXTERNAL_DISTRIBUTOR_SERVICE" ? (
                        dataList?.shippingPartner === "PICKER" ? (
                          <span
                            className={
                              "bg-gray-700 rounded p-1 px-2 text-white font-size-sm"
                            }
                          >
                            SHIP_ROCKET
                          </span>
                        ) : dataList?.isShipmentCancelled ? (
                          <>
                            <span
                              className={
                                dataList?.isShipmentCancelled
                                  ? ""
                                  : "bg-gray-700 rounded p-1 px-2 text-white font-size-sm"
                              }
                            >
                              {dataList?.isShipmentCancelled
                                ? ""
                                : dataList?.shippingPartner}
                            </span>
                            <div className="mt-1 text-gray-900 text-sm font-medium">
                              {dataList?.shippingPartner
                                ? dataList?.shipmentId
                                : ""}
                            </div>
                          </>
                        ) : !dataList?.isShipmentCancelled &&
                          dataList?.shippingPartner !== null ? (
                          <>
                            <span
                              className={
                                dataList?.isShipmentCancelled
                                  ? ""
                                  : dataList?.deliveryMode === "SELF"
                                    ? ""
                                    : "bg-gray-700 rounded p-1 px-2 text-white font-size-sm"
                              }
                            >
                              {dataList?.isShipmentCancelled
                                ? ""
                                : dataList?.shippingPartner === "PICKER"
                                  ? "SHIP_ROCKET"
                                  : dataList?.deliveryMode === "SELF"
                                    ? ""
                                    : dataList?.shippingPartner}
                            </span>
                            <div className="mt-1 text-gray-900 text-sm font-medium">
                              {dataList?.shippingPartner
                                ? dataList?.shipmentId
                                : ""}
                            </div>
                          </>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </div>
                  </td>

                  <td className="" nowrap="nowrap">
                    <span className="d-block mb-1">
                      {moment
                        .utc(dataList.purchasedDate)
                        .local()
                        .format("DD/MM/YYYY")}
                    </span>
                    <span>
                      {moment
                        .utc(dataList.purchasedDate)
                        .local()
                        .format("hh:mm A")}
                    </span>
                  </td>
                  <td>
                    <div className="d-flex flex-column align-items-center gap-2">
                      <Link
                        to={`/orderHistory/${dataList?.orderRefId}`}
                        state={{
                          Pagination: offset,
                          Filters: submit,
                          selectedTab: tabKey,
                          ManifestCreation: createManifest,
                          shipmentSelection: selectedShipments,

                          InvoiceCreation: createInvoice,
                          invoiceShipmentSelection: selectedInvoiceShipments,
                        }}
                      >
                        <i className="flaticon-eye icon-lg text-dark font-weight-bold text-hover-primary cursor-pointer mx-auto"></i>
                      </Link>

                      {dataList?.externalDeliveryMode ===
                        "EXTERNAL_DISTRIBUTOR_SERVICE" &&
                        dataList?.orderStatus !== "SHIPMENT_CANCELLED" &&
                        dataList?.orderStatus !== "CANCELLED" &&
                        shipmentId && (
                          <Tooltip title="Download Label">
                            <span className="cursor-pointer">
                              <DownloadOutlined
                                style={{ fontSize: "18px" }}
                                onClick={() => {
                                  dispatch(
                                    PrintLabelThunk({
                                      shipmentId: dataList?.shipRockedShipmentId
                                        ? dataList?.shipRockedShipmentId
                                        : dataList?.prozoAwbNumber
                                          ? dataList?.prozoAwbNumber
                                          : dataList?.courierPartnerShipmentId,
                                      shippingPartner:
                                        dataList?.shippingPartner,
                                    }),
                                  );
                                }}
                              />
                            </span>
                          </Tooltip>
                        )}
                    </div>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={10}>No Data Found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
